import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { filter } from 'rxjs';

const ROUTE_TITLE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  forms: 'Forms',
  login: 'Login',
  payment: 'Payment',
  profile: 'Profile',
  chatter: 'Chatter',
  squawks: 'Squawks',
  faq: 'FAQ',
  'trip-info': 'Trip Info',
  'trip-finances': 'Trip Finances',
  'prep-planning': 'Prep & Planning',
  'partner-info': 'Partner Info',
  'packing-list': 'Packing List',
  resources: 'Resources',
  'desktop-required': 'Desktop Required',
  'group-management': 'Group Management',
  'trip-documents': 'Trip Documents',
};

@Injectable({
  providedIn: 'root',
})
export class AppShellService {
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly transloco = inject(TranslocoService);

  initialize(): void {
    this.syncDocumentLang(this.transloco.getActiveLang());
    this.transloco.langChanges$.subscribe((lang) => {
      this.syncDocumentLang(lang);
    });

    this.updateDocumentTitle();
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateDocumentTitle();
      });
  }

  private syncDocumentLang(lang: string): void {
    document.documentElement.lang = lang;
  }

  private updateDocumentTitle(): void {
    const pathSegment =
      this.router.url.split('?')[0].split('/').filter(Boolean)[0] ?? 'dashboard';
    const pageLabel = ROUTE_TITLE_LABELS[pathSegment] ?? 'Pelican Account';
    this.title.setTitle(`Pelican Account — ${pageLabel}`);
  }
}
